import { Component } from 'react'
import { Field, reduxForm } from 'redux-form'
import submit from './submit.js'
import Input from '../../Form/Field/Input.jsx'
import validate from './validate.js'
import FormGlobalErrors from '../../Form/FormGlobalErrors.jsx'
import Loader from '../../../../shared/components/Loader/Loader.jsx'
import createOnSubmitFailHandler from '../../Form/createOnSubmitFailHandler.js'

export const name = 'ResetPasswordForm'

class ResetPasswordForm extends Component {
  constructor(props) {
    super(props)
    props.initialize({
      user: props.user,
      token: props.token
    })
  }

  render() {
    return (
      <div>
        <form onSubmit={this.props.handleSubmit}>
          <FormGlobalErrors className="mt-0" errors={this.props.error} />
          <Field
            label="Nouveau mot de passe"
            name="password"
            placeholder="Nouveau mot de passe"
            component={Input}
            type="password" />
          <Field
            label="Répétez votre mot de passe"
            name="repeat_password"
            placeholder="Nouveau mot de passe"
            component={Input}
            type="password" />
        </form>
        <Loader visible={this.props.submitting || this.props.triggerSubmit}></Loader>
      </div>
    )
  }
}

export default reduxForm({
  form: name,
  onSubmitFail: createOnSubmitFailHandler(name),
  onSubmit: submit,
  validate
})(ResetPasswordForm)